
export default {
    namespaced: true,
    state: {
        roomData: [],
        roomRoleInfoList: [],
        roomRoleInfoMap: new Map(),
        messageResp: null
    },
    mutations: {
        setRoomData(state, data) {
            state.roomData = data
        },
        setRoomRoleInfoList(state, list) {
            state.roomRoleInfoList = list
        },
        setRoomRoleInfoMap(state, map) {
            state.roomRoleInfoMap = map
            console.log('state.roomRoleInfoMap',state.roomRoleInfoMap)
        },
        setMessageResp(state, messageResp) {
            state.messageResp = messageResp
        },
    }
}
